@if (showNotProductionBanner) {
  <div class="not-production-banner"
    >
    <div class="not-production-banner__bar">
      <div class="not-production-banner__text">
        {{notProductionBannerText | translate}}
      </div>
    </div>
  </div>
}
@if (appUpdateService.isUpdateAvailable) {
  <div class="app-update-banner">
    @if (!appUpdateService.isUpdated) {
      <span>
        {{'Found a new version. Updating the app...' | translate}}
      </span>
    }
    @if (appUpdateService.isUpdated) {
      <span>
        {{'App is updated.' | translate}}
        @if (appUpdateService.canReloadApp) {
          <span>
            {{'Reloading the page...' | translate}}
          </span>
        }
        @if (!appUpdateService.canReloadApp) {
          <span>
            {{'You must refresh the page for the updates to take effect.' | translate}}
          </span>
        }
      </span>
    }
  </div>
}
@if (!showMenuInitializerService.showMenu) {
  <div>
    <div class="page-wrapper">
      <div class="page content">
        @if (!authenticationService.isAuthInitialized) {
          <div class="auth-loading">
            <div class="loading-spinner">
              <div class="spinner"></div>
              <p>{{'Loading...' | translate}}</p>
            </div>
          </div>
        }
        @if (authenticationService.isAuthInitialized) {
          <router-outlet></router-outlet>
        }
      </div>
    </div>
  </div>
} @else {
  <ng-progress [id]="PROGRESS_ID"></ng-progress>
  <mat-drawer-container>
    <mat-drawer #drawer
      mode="over"
      position="end">
      <sidenav (whatsNewSectionOpened)="onWhatsNewSectionOpened()" [whatsNewHighlighting]="showWhatsNewIndicatorMenu" [whatsNewMenuDisplay]="hasWhatsNewData"></sidenav>
    </mat-drawer>
    <div class="page-wrapper">
      <app-navbar (openMenu)="drawer.toggle()" (whatsNewSectionOpened)="onWhatsNewSectionOpened()" [whatsNewHighlighting]="showWhatsNewIndicatorMenu" [whatsNewMenuDisplay]="hasWhatsNewData"></app-navbar>
      <div class="page content">
        <router-outlet></router-outlet>
      </div>
      @if (hasWhatsNewData && showWhatsNewIndicator) {
        <app-whats-new-indicator (indicatorClosed)="showWhatsNewIndicator = false" (indicatorOpened)="onWhatsNewSectionOpened()"></app-whats-new-indicator>
      }
    </div>
  </mat-drawer-container>
}

<div class="footer" [class.footer--login]="showLoginFooter()">
  <div class="footer--right">
    <div>{{'VISION by Mobile Insight, Engage by Mobile Insight, Mobile Insight, VIBA are registered trademarks of Integrated Digital IP, LLC and are used under license by Acquisoft, LLC.' | translate}}</div>
    <div>
    © {{'Copyright' | translate}} {{CURRENT_YEAR}} {{'Integrated Digital IP, LLC All Rights Reserved' | translate}}</div>
    @if (router.url === '/home') {
      <div>
        Icons made by <a href="https://www.flaticon.com/authors/freepik" title="Freepik">Freepik</a> from <a
      href="https://www.flaticon.com/" title="Flaticon">Flaticon</a>
    </div>
  }
  <a href="https://mobileinsight.com/privacy/" target="_blank">{{'Privacy Policy' | translate}}</a>
  <div>{{'Version' | translate}} {{VERSION}}</div>
</div>
</div>

<ng-keyboard-shortcuts [shortcuts]="shortcuts"></ng-keyboard-shortcuts>
<ng-keyboard-shortcuts-help [key]="'f1'" [closeKey]="'escape'" [title]="'Help'"></ng-keyboard-shortcuts-help>
